import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import axios from "axios";
import './App.css';
import './common/polyfill.js'
import { customDataObjects, saveActivity, getTrackId } from './common/commonService';
import NewAppUser from './components/AppUser/NewAppUserReduxForm.js';
import AuthenticateUser from './components/AuthenticateUser.js';
import BusinessList from './components/Business/BusinessList';
import ChangePwd from './components/ChangePwd';
import TeamCreation from './components/TeamCreation';
import ModuleNLessonList from './components/Course/ModuleNLessonList.js';
import HandSimulator from './components/HandSimulator/HandSimulator';
import NewContent from './components/Course/NewContent.js';
import Home from './components/home.js';
import Login from './components/Login/Login';
import LoginWithClient from './components/LoginWithClient.js';
import MultipleReportCards from './components/MultipleReportCards/ReportCards.js';
import Course1 from './components/NewCourse/Course.js';
import CourseHome from './components/NewCourse/CourseHome.js';
import PlayerDetails from './components/PlayerDetails.js';
import PokerWatch from './components/PokerWatchComp/Pokerwatch.js';
import PokerWatchNew from './components/PokerWatchNew/Pokerwatch_new.js';
import PokerWatchTeam from './components/PokerWatchNew/PokerWatchTeam.js';
import PokerWatchReplayer from './components/PokerWatchNew/PokerWatchReplayer'
import PrivacyPolicy from './components/PrivacyPolicy.js';
import NewPromotionalContent from './components/PromotionalContent/NewPromotionalContent.js';
import PromotionalContentList from './components/PromotionalContent/PromotionalContentList.js';
import RedirectToMyGameFrmClient from './components/RedirectToMyGameFrmClient.js';
import { partypoker_login_url, partypoker_redirect_uri, adminSubDomain } from './common/config.js';
import MissionHome from './components/ReportCard/Missions/MissionHome.js'
import NewPlayerReportCard from './components/ReportCard/NewReporrCard/NewPlayerReportCard';
import ScrollToTop from './components/ScrollToTop';
import SharedReplayer from './components/HandReplayer/SharedReplayer.js';
import PopUpHandReplayer from './components/HandReplayer/PopUpHandReplayer.js';
import MultipleReplayerPopup from './components/HandReplayer/MultipleReplayerPopup.js';
import TournamentOverlayTypeList from './components/TournamentOverlay/TournamentOverlayTypeList.js';
import TournamentOverlayTypeUpsert from './components/TournamentOverlay/TournamentOverlayTypeUpsert.js';
import TournamentWatch from './components/TournamentWatch/TournamentWatch';
import AppUser from './container/AppUser/AppUser';
import Header from './container/Header/Header.js';
import HandHistory from './components/HandHistory/HandHistory';
import Spin from './components/ReportCard/Spin/Spin.js';
import MyAccount from './components/AppUser/MyAccount';
import './css/bootstrap.min.css';
import './css/common.css';
import './css/font-awesome.css';
import './css/login.css';
import './css/resp-table.css';
import './css/style.css';
import './css/fontawesome.min.css';
import '../node_modules/mygame-components/src/ReplayTable/Control.css'
import '../node_modules/mygame-components/src/ReplayTable/RangeBar.css'
import '../node_modules/mygame-components/src/ReplayTable/ReplayTable.css'
import '../node_modules/mygame-components/src/DownloadPopup/DownloadPopup.css'
import '../node_modules/mygame-components/src/DatePicker/input-moment.css'
import '../node_modules/mygame-components/src/DatePicker/InputDatePickerPopup.css'
import '../node_modules/mygame-components/src/css/shareReportCard.css'
import '../node_modules/mygame-components/src/css/ToggleSwitch.css'
import '../node_modules/mygame-components/src/css/shareToSocialMedia.css'
import '../node_modules/mygame-components/src/css/PlayerReportCardBeta.css'

import './css/reportCardMobileView.css';
import './css/socialShare.css';
import LoginRedirect from './components/LoginRedirect.js';
import LandingPage from './components/LandingPage/BaseStructure';
import {baseUrl} from './common/config.js';
import {apiService} from './common/apiCallService';
// import AuthenticateUser from './components/AuthenticateUser'
const qs = require('querystring');
const injectTapEventPlugin = require("react-tap-event-plugin");
injectTapEventPlugin();

import MyStatistics from './components/MyStatistics/MyStatistics';            
import queryString from 'query-string';
import { EditorFormatColorReset } from 'material-ui/svg-icons';
import LoggedOut from './components/LoggedOut';
import BrandLogin from './components/BrandLogin';
import moment from "moment";
import ViewSharedReportCard from './components/SharedReport/ViewSharedReportCard';
import { getColor, getDarkTextColor, getHoverColor, getTextColor } from './common/ThemeService';
import MyGameLogout from './components/MyGameLogout';
import DownloadFailedHands from './components/DownloadFailedHands';
var UAParser= require('ua-parser-js');
const browser = require('browser-detect');
const browserInfo = browser();
let ctrlKeyDown = false;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      access: JSON.parse(localStorage.getItem('userRole')),
      readyTorender : false,
      loading:true,
      fromClient:JSON.parse(localStorage.getItem('fromClient',false)),
    }
    this.handleToggle = this.handleToggle.bind(this)
    this.handleClose = this.handleClose.bind(this)
    if (localStorage.getItem('token') && localStorage.getItem('token').trim().length > 0 && window.location.pathname !== '/clientLogin') {
      new Promise((resolve, reject) => {
        AuthenticateUser.validateUser()
          .then((data) => {
            this.setState({
              loading:false
            })
            resolve(data)
            this.forceUpdate()
          })
          .catch((err) => {
            const loginPath = window.location.pathname + window.location.search
            localStorage.clear()
            if(loginPath != '/myGameLogut'){
                localStorage.setItem('pathName', loginPath)
            }
            this.setState({
              loading:false
            })
            if (err.responseJSON && loginPath != '/brandLogin'){  
              alert("Sorry, Your Session Expired, Please login again"); 
             }
          })
      })
    }
    else {
      this.state.loading = false;
    }

    // setInterval(() => {
    //   if (localStorage.getItem('token') && localStorage.getItem('activityTrack')) {
    //     let activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    //     localStorage.removeItem('activityTrack');
    //     saveActivity(activityTrack)
    //   }
    // }, 10000);
  }

  handleToggle() { this.setState({ open: true }); }
  handleClose() { this.setState({ open: false }); }
  
  isUserLoggedIn = () => new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      AuthenticateUser.validateUser()
        .then(_ => {
          resolve(true)
        })
        .catch(err => {
          resolve(false)
        })
    } else resolve(false)
  })

  getIp = () =>  new Promise((resolve, reject) => {
    axios.get('https://api.ipify.org?format=json')
      .then(function (response) {
        resolve(response.data.ip)
      })
      .catch(function (error) {
        resolve(null)
      });
  })
  
  
  componentDidMount() {
    const queryParams = queryString.parse(window.location.search);
    const {sId, id, tgt } = queryParams;
    let {fromClient} = queryParams;

    if(fromClient && fromClient === "true") {
      localStorage.clear();
      localStorage.setItem("fromClient",fromClient);
      console.log("fromClient: clear previous session data");
    }

    fromClient = JSON.parse(localStorage.getItem('fromClient')) || false

    if(localStorage.getItem('accountName') && (!localStorage.getItem("activity_tracking_token") || localStorage.getItem("activity_tracking_token") == '')) {
      apiService(baseUrl + '/appUser/generateActivityHitsToken', { accountName: localStorage.getItem('accountName') }, (data) => {
        localStorage.setItem("activity_tracking_token", data.token)
      }, (err) => {
        console.log(err);
      })
    }

    // apiService(baseUrl + '/appUser/getRedisData', { accountName: localStorage.getItem('accountName') }, (data) => {
    //  console.log("data.disableLangauge",data.disableLangauge);
    //   localStorage.setItem("disableLangauge", data.disableLangauge)
    // }, (err) => {
    //   console.log(err);
    // })
    var parser = new UAParser(),
      result = parser.getResult(),
      upgradeVersion = false,
      os = result.os.name ? result.os.name : ''
    if (os.toLowerCase().indexOf('mac') != -1) {
      if (parseFloat(result.os.version) < 10.14) {
        upgradeVersion = true
        alert('Not supported for this OS version')
      }
    }
    localStorage.setItem("accountNames",JSON.stringify([]));
    if (localStorage.getItem('username') != null || localStorage.getItem('username') != '') {
      customDataObjects("UserID", localStorage.getItem('username'))
    } else if (localStorage.getItem('trackerId') != null || localStorage.getItem('trackerId') != '') {
      customDataObjects("TrackerID", localStorage.getItem('trackerId'))
    }
    this.geoInfo();
    let actvTrack={};
    if(tgt) this.setState({blankPage : true});
    // if (sId && sId != "undefined") {
    if (sId) {
      Promise.all([
        // this.isUserLoggedIn(),
        this.getIp()
      ])
        .then(([isUserLoggedIn, deviceIp]) => {
          actvTrack = AuthenticateUser.activityTrack;
          actvTrack.hit_page = 'Tracking Tag';
          actvTrack.hit_type = 'Tracking Tag';
          actvTrack.hit_attribute1 = sId;
          if (id) actvTrack.hit_attribute2 = id
          actvTrack.hit_attribute3 = window.location.pathname
          actvTrack.userid = localStorage.getItem('username') ? localStorage.getItem('username') : getTrackId();
          actvTrack.session_id = localStorage.getItem('token') ? localStorage.getItem('token') : 'anonymous';
          const deviceInfo = {
            device_type:browserInfo.mobile ? 'Mobile' : 'Desktop',
            browser_type:browserInfo.name,
            browser_version:browserInfo.version,
            language:navigator.language,
            ip:deviceIp,
          }
          console.log("deviceInfo",deviceInfo)
          actvTrack.deviceInfo = deviceInfo;
          actvTrack.hit_attribute6 = localStorage.getItem('accountName') ? localStorage.getItem('accountName') : 'NotLoggedIn'
          // console.log(actvTrack)
          if(tgt) {
            location.replace(tgt)
          } else {
            if(!isUserLoggedIn && window.location.pathname != "/clientLogin") {
              this.redirectToLogin(window.location.hostname)
            }
          }
        })
        .catch(async (err) => {
          actvTrack.userid = this.generateId();
          actvTrack.session_id = 'anonymous'
        })
        .finally(_ => {
          saveActivity(actvTrack);
          if(tgt) location.replace(tgt);
          else this.setState({readyTorender : true})
        })                        
    } else this.setState({readyTorender : true}) 
    
    localStorage.setItem("myGameOpenTime", moment.utc());
      if (JSON.parse(localStorage.getItem("fromClient"))) {
        window.addEventListener('keydown', this.disableF5.bind(this));
        window.addEventListener('keyup', this.keyup.bind(this))
    }
  }

 beforeunload(e) {
    e.preventDefault();
    e.returnValue = true;
}
disableF5(e) {
  if ((e.which || e.keyCode) == 116 || ((e.which || e.keyCode) == 82 && ctrlKeyDown) || (e.metakey)) {
    e.preventDefault();
  } else if ((e.which || e.keyCode) == 17) {
    ctrlKeyDown = true;
  }
};
keyup(e) {
  if ((e.which || e.keyCode) == 17)
    ctrlKeyDown = false;
};

handle()  {
  console.log('Before unload');
  let myGameOpenTime = localStorage.getItem("myGameOpenTime");
  let currenTime = moment.utc();
    let sessionDurationInSeconds = moment(currenTime).diff(moment(myGameOpenTime), "seconds")
    let track = {}
    track.hit_page = 'MyGame'
    track.hit_type = "Close"
    track.hit_attribute2 = sessionDurationInSeconds
    track.hit_attribute6 = localStorage.getItem("accountName")
    saveActivity(track);
    if (localStorage.getItem('token') && localStorage.getItem('activityTrack')) {
      let activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
      localStorage.removeItem('activityTrack');
      if(activityTrack && activityTrack.length > 0) {
        activityTrack.map(act => saveActivity(act))
      }
    }
}
  geoInfo(){
    let deviceInfo = {
      ip:null,
      country:''
    }
    return new Promise((resolve, reject) => {
      axios.get('https://api.ipify.org?format=json')
      .then((response) => {
          deviceInfo.ip=response.data.ip;
          deviceInfo.country='';
          localStorage.setItem("deviceInfo",JSON.stringify(deviceInfo))
          resolve()
      })
      .catch((error) => {
          localStorage.setItem("deviceInfo",JSON.stringify(deviceInfo))
          resolve()
      });
    })
  }
  generateId() {
    let text = localStorage.getItem('trackerId');
    if (!text) {
      const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 15; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      localStorage.setItem('trackerId', text);
    }
    return text;
  }

  getIp = () => {
    return axios.get('https://api.ipify.org?format=json')
      .then(function (response) {
        return response.data.ip
      })
      .catch(function (error) {
        return null
      });
  }
  componentWillUnmount = () => {
    window.removeEventListener('keydown', this.disableF5.bind(this));
    window.removeEventListener('keyup', this.keyup.bind(this));
  }
  render() {
      if(this.state.loading === true) {
        return <div>
          Loading
        </div>;
      }
    const addMaximumScaleToMetaViewport = () => {
      const el = document.querySelector('meta[name=viewport]');
      if (el !== null) {
        let content = el.getAttribute('content');
        let re = /maximum\-scale=[0-9\.]+/g;
    
        if (re.test(content)) {
            content = content.replace(re, 'maximum-scale=1.0');
        } else {
            content = [content, 'maximum-scale=1.0'].join(', ')
        }
    
        el.setAttribute('content', content);
      }
    };
    
    const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;
    
    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    const checkIsIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (checkIsIOS()) {
      disableIosTextFieldZoom();
    }

    return (
        <MuiThemeProvider muiTheme={getMuiTheme(darkBaseTheme)}>
          {this.state.readyTorender ?

        
        <Router >
          <ScrollToTop>
            <Switch>
            <Route exact path="/sharedReport/:shareId" component={ViewSharedReportCard}/>
              <Route exact path="/" component={LoginRedirect}/>
              <Route exact path="/loggedOut" component={LoggedOut} />
              {/* <Route exact path="/" component={Login} /> */}
              <Route exact path="/mygamelogin" component={Home} />
              <Route exact path="/privacypolicy" component={PrivacyPolicy} />
              <Route exact path="/clientLogin" component={LoginWithClient} />
              <Route exact path="/RedirectToMyGameFrmClient" component={RedirectToMyGameFrmClient} />
              <Route path="/brandLogin/:brand?/:locale?" component={BrandLogin} />
              <Route
                path="/course/:course/:lesson"
                component={Course1}
                title={this.props.title}
              />
              <Route
                path="/course/:course"
                component={Course1}
                title={this.props.title}
              />
              <Route
                path="/course"
                component={CourseHome}
                title={this.props.title}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/pokerwatch"
                component={PokerWatchNew}
                title={this.props.title}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/pokerwatchreplayer"
                component={PokerWatchReplayer}
                title={this.props.title}
              />
               <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER','COACH']}
                path="/pokerwatchteam"
                component={PokerWatchTeam}
                title={this.props.title}
              />
              <Route
                path="/replayer"
                component={SharedReplayer}
                title={this.props.title}
              />
              <PrivateRoute
                path="/course/:course/:lesson"
                component={Course1}
                title={this.props.title}
              />
              <PrivateRoute
                path="/course/:course"
                component={Course1}
                title={this.props.title}
              />
              <PrivateRoute
                path="/course"
                component={CourseHome}
                title={this.props.title}
              />

              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH']}
                path="/playerDetails/:date/:toDate/:fTime/:tTime/:shift/:players_alias/:accountName"
                component={PlayerDetails}
              />
              {/* <PrivateRoute
              userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH']}
              path="/skillLevels/:fromDate/:toDate/:fromTime/:toTime/:shift/:playerName/:totalGame"
              component={MultipleReportCards}
              title={this.props.title}
            /> */}
              <PrivateRoute
                path="/skillLevels/:gameType/:accountName/:fromDate/:toDate/:shift"
                component={this.props.gameType=== 'spin' ? Spin : NewPlayerReportCard}
                title={this.props.title}
              />
              <PrivateRoute
                path={"/myskillLevels/:gameType/:accountName"}
                // component={NewPlayerReportCard}
                component={NewPlayerReportCard}
                title={this.props.title}
              />
              {/* <PrivateRoute
              path="/myskillLevels"
              component={MultipleReportCards}
              title={this.props.title}
            /> */}
            <PrivateRoute
                userRole={['PLAYER']}
                path="/Home"
                component={LandingPage}
                title={this.props.title}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                path="/SkillLevel"
                component={MultipleReportCards}
                title={this.props.title}
              />
              <PrivateRoute
                path="/ReportCard/:accountName/:gameType"
                component={this.props.gameType=== 'spin' ? Spin : NewPlayerReportCard}
                title={this.props.title}
              />
               <PrivateRoute
                path="/MyStatistics"
                component={MyStatistics}
                title={this.props.title}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/appUserComp"
                component={AppUser}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/businessList"
                component={BusinessList}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/newAppUser"
                component={NewAppUser}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH']}
                path="/playerSummary"
                component={PlayerDetails}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN']}
                path="/PromotionalContent/list"
                component={PromotionalContentList}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN']}
                path="/PromotionalContent/new"
                component={NewPromotionalContent}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN']}
                path="/PromotionalContent/edit/:id"
                component={NewPromotionalContent}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                path="/changePwd"
                component={ChangePwd}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN']}
                path="/teamCreation"
                component={TeamCreation}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN']}
                path="/newContent"
                component={NewContent}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN']}
                path="/moduleNlessonList"
                component={ModuleNLessonList}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN','PLAYER']}
                path="/handSimulator"
                component={HandSimulator}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                path="/missions"
                component={MissionHome}
                title={this.props.title}
              />
                {!(JSON.parse(localStorage.getItem('fromClient'))) ? <PrivateRoute
                  userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                  path="/reportCardCourse/:module"
                  component={Course1}
                  title={this.props.title}
                /> :
                  <Route
                    path="/reportCardCourse/:module"
                    component={Course1}
                    title={this.props.title}
                  />}
                <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                path="/myGameLogut"
                component={MyGameLogout}
                title={this.props.title}
              />
                <PrivateRoute
                  path="/Spin"
                  component={Spin}
                  title={this.props.title}
                />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/editAppUser/:id"
                component={NewAppUser}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/tournamenttype"
                component={TournamentOverlayTypeList}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/tournamentupsert/:id"
                component={TournamentOverlayTypeUpsert}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'BUSINESS_OWNER']}
                path="/tournamentwatch"
                component={TournamentWatch}
              />
              <PrivateRoute
                userRole={['PLAYER']}
                path="/MyHands"
                component={HandHistory}
              />
              <PrivateRoute
                userRole={['PLAYER']}
                path="/MyFailedHands"
                component={DownloadFailedHands}
              />
               <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH']}
                path="/myaccount"
                component={MyAccount}
                title="My Account"
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                path="/PopUpHandReplayer/:gameType/:gameNumber/:accountName/:time"
                component={PopUpHandReplayer}
              />
              <PrivateRoute
                userRole={['SYS_ADMIN', 'SHIFT_MANAGER', 'BUSINESS_OWNER', 'COACH', 'PLAYER']}
                path="/MultipleReplayerPopup"
                component={MultipleReplayerPopup}
              />
              {AuthenticateUser.isAuthenticated && this.state.access
               ?
               this.state.access.indexOf('SHIFT_MANAGER') !== -1 || this.state.access.indexOf('COACH') !== -1 || this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1
                 ? <Redirect to="/pokerwatch" />
                //  : <Redirect to="/SkillLevel?logintype=player" />
                 : <Redirect to="/" />
               : <Redirect to="/" />}
            </Switch>
          </ScrollToTop>
        {/* </SourceTracking> */}
        </Router>
        : null}
      </MuiThemeProvider>
    )
  }
}



const PrivateRoute = ({ component: Component, ...rest }) => {
  ['My Statistics'].indexOf(rest.title) >= 0 
    ? document.body.style.backgroundColor = "#FAFAFA" :
      ['Mission', 'Course', 'Report Card','Spin Report Card', 'Skill Levels','MyGame Home'].indexOf(rest.title) != -1
        ? ['Mission','Skill Levels', 'Report Card','Spin Report Card','MyGame Home'].indexOf(rest.title) != -1
          ? document.body.style.backgroundColor = "#FAFAFA" :  document.body.style.backgroundColor = "#F7F7F7"
        : ['Poker Watch New'].indexOf(rest.title) != -1 || ['My Account'].indexOf(rest.title) !=-1 ? document.body.style.backgroundColor = "white"
        : ['Pokerwatch-Player'].indexOf(rest.title) != -1 ?document.body.style.backgroundColor = "white"
        : ['Poker Watch Team'].indexOf(rest.title)  !=-1?document.body.style.backgroundColor = "white": document.body.style.backgroundColor = "rgb(230, 230, 230)";
       
  let authenticateRole = false,
    access = JSON.parse(localStorage.getItem('userRole'))
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const themeHoverColor = getHoverColor()
    const themeDarkTextColor = getDarkTextColor()
  if (access && rest.userRole) {
    rest.userRole.map((key) => {
      access.map((role) => {
        if (role == key)
          authenticateRole = true
      })
    })
  }
  else authenticateRole = true
  let redirectTo = ''
  if (localStorage.getItem('loggedInType') === 'myGame' || localStorage.getItem('loggedInType') === 'MyGame') redirectTo = <Redirect to={'/mygamelogin'} />
  else if (localStorage.getItem('loggedInType') === 'partyPoker') redirectTo = <Redirect to={'/'} />
  else if (localStorage.getItem('loggedInType') === 'Danskespil') redirectTo = <Redirect to={'/loggedOut'} />
  else if (localStorage.getItem('loggedInType') && rest.brandAuthConfig && Object.keys(rest.brandAuthConfig).includes(localStorage.getItem('loggedInType').toLowerCase())) 
  {
    redirectTo = <Redirect to={'/brandLogin'} />
}
  else {
    if(window.location.pathname != '/myGameLogut'){
      localStorage.setItem('pathName', window.location.pathname + window.location.search)
    }
      redirectTo = <Redirect to={'/'} />}
  return (
  
    <Route {...rest} render={props => (
      localStorage.getItem('token') && authenticateRole
        ? <div data-e2e="flexElement" className=''>
          <style>
            {`
            .shareToMomentButton {\
              color: ${themeDarkTextColor};\
              border-color: ${themeColor};\
            }\
            .multiReplayer_crossButton, .mutireplayer_shareHandButton {\
              background-color: ${themeColor};\
              color: ${themeTextColor};\
              border-color: ${themeColor};\
            }\
            .multiReplayer_crossButton:hover, .mutireplayer_shareHandButton:hover {\
              background-color: #FFFFFF;\
              color: ${themeDarkTextColor};\
            }\
            .shareToMomentButton:hover {\
              background-color: ${themeHoverColor};\
            }\
          `}
          </style>
          <Header/>
          <div className={`content-container
           ${(['Skill Levels', 'Report Card', 'Spin Report Card', 'MyGame Home'].indexOf(rest.title) != -1||  rest.path === '/missions' || rest.path === '/course' ||rest.path==='/MyFailedHands') ? '' : 'container'}
           ${['Mission', 'Course', 'Report Card', 'Spin Report Card','MyGame Home'].indexOf(rest.title) != -1
               ? rest.title == 'Mission' ? `changeContainerStyle`
                 : ['Skill Levels', 'Report Card','MyGame Home'].indexOf(rest.title) != -1 
                   ? [ 'Report Card'].indexOf(rest.title) != -1 ? "lighterBackGroundColor"  :
                    ['MyGame Home'].indexOf(rest.title) != -1 ? `mygameLandingBackground`:`offwhiteback` 
                   : `changeBackgroundColor` : ``}`}>
            <Component {...props} />
          </div>
          {/* {rest.title != 'Mission' && <Footer />} */}
        </div>
        : redirectTo
      //  <Redirect to={{  pathname: '/',  state: { from: props.location },authenticateRole :{authenticateRole}}} />}
    )} />
  )
}



const mapStateToProps = (state) => ({
  title: state.header.title,
  gameType: state.multipleReportCards.gameType,
  brandAuthConfig: state.commonReducer.brandAuthConfig
})
export default connect(mapStateToProps, null)(App);


/** WEBPACK FOOTER **
 ** ./src/App.js
 **/